import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { getCalendarSettings, saveCalendarSettings, getCalendarStatus } from '../../services/api';
import { CalendarBlank } from '@phosphor-icons/react';
import { toast } from 'sonner';

export function IntegrationSettings() {
  const [gcalClientId, setGcalClientId] = useState('');
  const [gcalClientSecret, setGcalClientSecret] = useState('');
  const [gcalHasSecret, setGcalHasSecret] = useState(false);
  const [gcalStatus, setGcalStatus] = useState(null);

  useEffect(() => { fetchGcalSettings(); }, []);

  const fetchGcalSettings = async () => {
    try {
      const [settingsRes, statusRes] = await Promise.all([getCalendarSettings(), getCalendarStatus()]);
      setGcalClientId(settingsRes.data.client_id || '');
      setGcalHasSecret(settingsRes.data.has_secret || false);
      setGcalStatus(statusRes.data);
    } catch {}
  };

  const handleSaveGcalSettings = async () => {
    try {
      const payload = { client_id: gcalClientId };
      if (gcalClientSecret) payload.client_secret = gcalClientSecret;
      await saveCalendarSettings(payload);
      toast.success('Parametres Google Calendar sauvegardes');
      setGcalClientSecret('');
      fetchGcalSettings();
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
  };

  return (
    <Card className="border-[#E8E6E1]" data-testid="gcal-config">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <CalendarBlank size={18} className="text-[#2D5A4C]" />
          Google Calendar
          {gcalStatus?.connected && <Badge className="ml-2 bg-green-100 text-green-800 text-[10px]">Connecte</Badge>}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-xs text-[#5E6D66]">Configurez les identifiants OAuth pour permettre la synchronisation avec Google Calendar. Vous devez creer un projet sur Google Cloud Console et activer l'API Calendar.</p>
        {gcalStatus?.connected && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-sm text-green-800">Connecte en tant que <strong>{gcalStatus.email}</strong></p>
            <p className="text-xs text-green-600 mt-0.5">Connecte le {gcalStatus.connected_at ? new Date(gcalStatus.connected_at).toLocaleDateString('fr-FR') : ''}</p>
          </div>
        )}
        <div className="grid grid-cols-1 gap-4">
          <div className="space-y-2"><Label>Client ID</Label><Input value={gcalClientId} onChange={(e) => setGcalClientId(e.target.value)} placeholder="xxxx.apps.googleusercontent.com" data-testid="gcal-client-id" /></div>
          <div className="space-y-2"><Label>Client Secret {gcalHasSecret && <span className="text-[10px] text-[#5E6D66]">(deja configure)</span>}</Label><Input type="password" value={gcalClientSecret} onChange={(e) => setGcalClientSecret(e.target.value)} placeholder={gcalHasSecret ? '********' : 'GOCSPX-xxxxxx'} data-testid="gcal-client-secret" /></div>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={handleSaveGcalSettings} className="bg-[#2D5A4C] hover:bg-[#1E4136]" data-testid="gcal-save-btn">Sauvegarder</Button>
          <p className="text-[10px] text-[#5E6D66]">Redirect URI: <code className="bg-[#F0EFEB] px-1 rounded">{window.location.origin}/api/oauth/calendar/callback</code></p>
        </div>
      </CardContent>
    </Card>
  );
}
